const selectors = {
    wrapper: '.js-tabs-wrapper',
    tab: '.js-tab',
    section: '.js-tab-section'
};

const states = {
    isActive: 'is-active'
};

const onTabClick = function (evt) {
    evt.preventDefault();

    const $this = $(evt.currentTarget);

    if ($this.hasClass(states.isActive)) {
        return;
    }

    const $wrapper = $this.closest(selectors.wrapper);
    const $targetSection = $($this.attr('href'));

    $wrapper.find(`.${states.isActive}`).removeClass(states.isActive);

    $wrapper.find(`${selectors.section}.${states.isActive}`).removeClass(states.isActive);

    $this.addClass(states.isActive);

    $targetSection.addClass(states.isActive);
};

export default {
    init() {
        const $contentTabs = $(selectors.wrapper);

        if (!$contentTabs.length) {
            return;
        }

        $contentTabs.on('click', `${selectors.tab}`, onTabClick);
    }
};
